import { GoatCrossedArms, useIntl } from '@capsicum/common';
import { Image } from '@capsicum/common-web';
import styled from 'styled-components';

import { NftTooltip } from '../nfts-tooltip/NftTooltip';

const NoNftsCard = ({ onTriggerClick }: { onTriggerClick?: () => void }) => {
	const { $t } = useIntl();

	const digitalCollectiblesTexts = {
		emptyList: $t('ncWallet.nfts.emptyList'),
		goatAlt: $t('ncWallet.nfts.goatAlt')
	};

	return (
		<S.EmptyContainer data-testid="noNftsCard-card">
			<Image alt={digitalCollectiblesTexts.goatAlt} src={GoatCrossedArms}></Image>
			<S.EmptyContainerTitleWrapper>
				<S.Title2>{digitalCollectiblesTexts.emptyList}</S.Title2>
				<NftTooltip onTriggerClick={onTriggerClick} />
			</S.EmptyContainerTitleWrapper>
		</S.EmptyContainer>
	);
};

namespace S {
	export const EmptyContainer = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-bottom: ${({ theme }) => theme.spacings.xxlarge};
	`;

	export const EmptyContainerTitleWrapper = styled.div`
		display: flex;
		flex-direction: row;
		gap: ${({ theme }) => theme.spacings.xsmall};
		justify-content: center;
		align-items: center;
	`;

	export const Title2 = styled.span`
		color: ${({ theme }) => theme.colors.text.main.subtle};
		${({ theme }) => theme.fonts.text.text1}
		text-align:center;
		width: 100%;
	`;
}

export { NoNftsCard };
